import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

// Import reducers
import authReducer from '../features/auth/authSlice';
import productsReducer from '../features/products/productsSlice';
import cartReducer from '../features/cart/cartSlice';
import editorReducer from '../features/editor/editorSlice';
import ordersReducer from '../features/orders/ordersSlice';
import designsReducer from '../features/designs/designsSlice';
import vendorReducer from '../features/vendor/vendorSlice';
import adminReducer from '../features/admin/adminSlice';
import quotesReducer from '../features/quotes/quotesSlice';

// Persist configuration
const persistConfig = {
  key: 'packdealz',
  version: 1,
  storage,
  whitelist: ['cart', 'editor'], // Supabase handles auth persistence
};

const rootReducer = combineReducers({
  auth: authReducer,
  products: productsReducer,
  cart: cartReducer,
  editor: editorReducer,
  orders: ordersReducer,
  quotes: quotesReducer,
  designs: designsReducer,
  vendor: vendorReducer,
  admin: adminReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
